import React, { useEffect } from 'react'
import ReactModal from 'react-modal'

const Modal = ({
  isOpen = false,
  onRequestClose = null,
  children,
  className = '',
  overlayClassName = '',
  whiteBg = false,
  widgetType = 'banner', // or card
}) => {
  useEffect(() => {
    if (widgetType === 'banner') {
      ReactModal.setAppElement('.redfunnel__banner')
    } else {
      ReactModal.setAppElement('.redfunnel__card')
    }
  }, [widgetType])

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={`${
        whiteBg ? 'bg-white' : 'bg-black'
      } ${overlayClassName}`}
      className={`absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 max-h-[100%] overflow-y-auto ${className}`}
    >
      {children}
    </ReactModal>
  )
}

export default Modal
